import { Box } from "@mui/material";

import InteractiveOptions from "@/components/molecules/ChatBalloon/components/InteractiveOptions";
import WhatsAppMessageText from "@/components/molecules/ChatBalloon/components/WhatsAppMessageText";
import { CHAT_MEDIA_MAX_HEIGHT_PX } from "@/components/molecules/ChatBalloon/media-size";
import { CampaignTemplateRender } from "@/helpers/chat-campaign-template";

type CampaignMessageProps = {
  campaign: CampaignTemplateRender;
  isSentByUser: boolean;
};

export default function CampaignMessage({ campaign, isSentByUser }: CampaignMessageProps) {
  const textColor = isSentByUser ? "white" : "dark";

  return (
    <>
      {campaign.imageUrl && (
        <Box
          mx={-2}
          mt={-2}
          mb={campaign.body || campaign.footerCode ? 1.5 : 0}
          sx={{ overflow: "hidden" }}
        >
          <img
            src={campaign.imageUrl}
            alt=""
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              maxHeight: CHAT_MEDIA_MAX_HEIGHT_PX,
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Box>
      )}
      {campaign.body && <WhatsAppMessageText text={campaign.body} color={textColor} />}
      {campaign.footerCode && (
        <InteractiveOptions options={[{ label: campaign.footerCode }]} isSentByUser={isSentByUser} />
      )}
    </>
  );
}
